import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { inr } from "@/lib/api";
import { Plus, Edit2, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminProducts() {
  const [list, setList] = useState([]);
  const load = () => api.get("/products?limit=200").then(r => setList(r.data));
  useEffect(() => { load(); }, []);
  const del = async (id) => { if(!window.confirm("Delete this product?")) return; await api.delete(`/products/${id}`); load(); toast.success("Deleted"); };
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-display text-3xl font-bold">Products</h1>
        <Link data-testid="add-product-btn" to="/admin/products/new" className="btn-primary-sf inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold"><Plus size={16}/> Add Product</Link>
      </div>
      <div className="bg-white border border-slate-100 rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500"><tr><th className="text-left p-3">Product</th><th>Brand</th><th>Price</th><th>Stock</th><th>Tags</th><th></th></tr></thead>
          <tbody>{list.map(p => (
            <tr key={p.product_id} className="border-t border-slate-100">
              <td className="p-3 flex items-center gap-3"><img src={p.images?.[0]} className="w-10 h-12 rounded object-cover"/><div><div className="font-medium">{p.title}</div><div className="text-xs text-slate-500">{p.category}</div></div></td>
              <td className="text-center">{p.brand}</td>
              <td className="text-center font-semibold">{inr(p.price)}</td>
              <td className="text-center">{p.stock}</td>
              <td className="text-center text-xs">{[p.is_trending&&"🔥",p.is_bestseller&&"⭐",p.is_new&&"🆕"].filter(Boolean).join(" ")}</td>
              <td className="text-right p-3 space-x-1">
                <Link data-testid={`edit-${p.product_id}`} to={`/admin/products/${p.product_id}`} className="inline-flex p-2 hover:bg-slate-100 rounded"><Edit2 size={14}/></Link>
                <button data-testid={`del-${p.product_id}`} onClick={()=>del(p.product_id)} className="inline-flex p-2 hover:bg-slate-100 rounded text-red-600"><Trash2 size={14}/></button>
              </td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
